<template>
    <v-col :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-row v-if="project && isLoaded" no-gutters>
            <v-col class="grow">
                <!-- header -->
                <v-row no-gutters class="mb-6">
                    <v-col>
                        <div class="project-heading">
                            <router-link
                                :to="{ name: 'client_profile_projects', params: { id: project.client_id }}"
                                style="text-decoration: none"
                                class="d-flex overflow-hidden"
                            >
                                <ClientAvatar
                                    clickable
                                    :color="project.client_id_disp.color"
                                    :initials="project.client_id_disp.client_initials"
                                ></ClientAvatar>
                                <span class="headline font-weight-regular main--text ml-3 overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">
                                    {{ project.client_id_disp.name }}
                                </span>
                            </router-link>
                            <div class="ml-6">
                                <icon :color="project.color" icon="ClipboardList" />
                            </div>
                            <span class="headline font-weight-bold ml-3 overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ project.name }}</span>
                            <span v-if="canEddClient" class="ml-6">
                                <v-btn icon text color="grey" @click="editProjectClick">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </span>
                        </div>
                    </v-col>
                </v-row>
                <!-- navigation -->
                <v-row no-gutters>
                    <v-col>
                        <v-tabs
                            :value="activeTab"
                            background-color="transparent"
                            class="denser-tabs"
                            slider-size="4"
                        >
                            <v-tab
                                v-for="tab in tabs"
                                :key="tab.value"
                                @click="onNavTabClick(tab, $event)"
                            >
                                <span class="caption font-weight-medium">
                                    {{ tab.text }}
                                </span>
                            </v-tab>
                        </v-tabs>
                    </v-col>
                </v-row>
                <!-- content -->
                <v-row no-gutters>
                    <v-col>
                        <router-view :project="project" @clone_project="cloneProject" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { computed, ref, onUnmounted } from "@vue/composition-api";
import { $t } from "@/i18n";
import AppModule from "../../store/modules/app";
import ProjectModule from "../../store/modules/project";
import AccountAvatar from "@/components/AccountAvatar";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import ClientAvatar from "@/components/ClientAvatar.vue";

export default {
    name: "ProjectView",
    components: {
        ClientAvatar,
        AccountAvatar
    },
    setup(props, ctx) {
        const { fetchProject, current_project } = ProjectModule();
        const { fetchClassifiers, rights_masks } = AppModule();

        const isLoaded = ref(false)

        const projectId = computed(() => Number(ctx.root._route.params.id));
        const canEddClient = computed(() => {
            if (current_project.value == null) return false;
            return current_project.value.rights & rights_masks.value.manage_client === rights_masks.value.manage_client;
        });
        const tabs = [
            { text: $t("Tasks"), value: "tasks", route: { name: "project_tasks" }},
            { text: $t("Notes"), value: "notes", route: { name: "project_notes" }},
            { text: $t("Communication"), value: "communication", route: { name: "project_communication" }},
            { text: $t("Log"), value: "activity", route: { name: "project_activity" }}
        ];
        const activeTab = computed(() => {
            let current_route = ctx.root._route;
            return tabs.findIndex(tab => tab.route.name === current_route.name);
        });

        const loadData = () => {
            fetchProject(projectId.value)
                .then(() => {
                    isLoaded.value = true
                    fetchClassifiers({ types: ["progress_steps", "custom_fields", "project_types"], account_id: current_project.value.account_id })
                        .catch(ex => errorDialog.showError(ex));
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const editProjectClick = () => {
            ctx.root._router.push({
                name: "project_edit",
                params: { id: projectId.value },
            });
        }
        const onNavTabClick = (tab, ev) => {
            ctx.root._router.push({
                name: tab.route.name,
                params: { id: projectId.value },
            });
        };
        const cloneProject = () => {
            ctx.root._router.push({
                name: "project_new",
                params: {
                    account_id: current_project.value.account_id,
                    project_type_id: current_project.value.project_type_id,
                },
                query: { clone_id: projectId.value }
            });
        }

        loadData();

        return {
            project: current_project,
            tabs,
            activeTab,
            canEddClient,
            editProjectClick,
            onNavTabClick,
            cloneProject,
            isLoaded
        };
    }
};
</script>
